const paths = {
  upload: 'M12 16V3m-5 5 5-5 5 5M4 15v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5',
  file: 'M14 2H5v20h14V7l-5-5Zm0 0v6h5M8 12h8m-8 4h6',
  left: 'm14 6-6 6 6 6', right: 'm10 6 6 6-6 6',
  first: 'M5 5v14m12-13-6 6 6 6', last: 'M19 5v14M7 6l6 6-6 6',
  plus: 'M5 12h14M12 5v14', minus: 'M5 12h14',
  expand: 'M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5',
  close: 'm6 6 12 12M6 18 18 6', panel: 'M3 4h18v16H3zM14 4v16',
  select: 'M4 4h6M4 4v6m16-6h-6m6 0v6M4 20h6m-6 0v-6m16 6h-6m6 0v-6',
  hand: 'M8 12V5a2 2 0 0 1 4 0v6-7a2 2 0 0 1 4 0v7-5a2 2 0 0 1 4 0v8c0 5-3 8-7 8h-1c-2 0-3-1-4-3L3 12a2 2 0 0 1 3-2l2 2Z',
  code: 'm8 7-5 5 5 5m8-10 5 5-5 5m-3-14-2 18', copy: 'M8 8h13v13H8zM16 3H3v13',
  check: 'm5 12 4 4L19 6', download: 'M12 3v13m-5-5 5 5 5-5M4 17v4h16v-4',
  sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-6v2m0 16v2M2 12h2m16 0h2M5 5l1 1m12 12 1 1M5 19l1-1M18 6l1-1',
  moon: 'M21 13A9 9 0 0 1 11 3a9 9 0 1 0 10 10Z', menu: 'M4 6h16M4 12h16M4 18h16',
};
export default function StudioIcon({ name, size = 18 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] || paths.file} /></svg>;
}
